"use client";
import { createContext, PropsWithChildren, useCallback, useContext, useMemo } from "react";
import { Session } from "next-auth";
import { useSession } from "next-auth/react";
import { GqlClient } from "@/Providers/gqlClients/GqlClient";
import { ResponseMiddleware } from "graphql-request";

const GQLContext = createContext<{
  session: Session | null;
}>({
  session: null,
});
export const useGqlClient = () => {
  const { session } = useContext(GQLContext);
  // const handleResponseMiddleware: ResponseMiddleware = useCallback((response) => {
  //   if (response instanceof Error) {
  //   } else {
  //   }
  // }, []);

  const gql = new GqlClient(
    session,
    // { responseMiddleware: handleResponseMiddleware }
  );
  return gql.gqlClient;
};

export default function GQLProvider({ children, session }: PropsWithChildren & { session: Session | null }) {
  const { data, update, status } = useSession();
  const s = useMemo(() => {
    return data ?? session;
  }, [data, session]);
  return <GQLContext.Provider value={{ session: s }}>{children}</GQLContext.Provider>;
}
